/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  AuditInfo,
  AuditInfoFromJSON,
  AuditInfoFromJSONTyped,
  AuditInfoToJSON,
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
} from "./";

/**
 *
 * @export
 * @interface AuditInfoControllerResponse
 */
export interface AuditInfoControllerResponse {
  /**
   *
   * @type {AuditInfo}
   * @memberof AuditInfoControllerResponse
   */
  data?: AuditInfo;
  /**
   *
   * @type {ErrorResponse}
   * @memberof AuditInfoControllerResponse
   */
  error?: ErrorResponse;
}

export function AuditInfoControllerResponseFromJSON(json: any): AuditInfoControllerResponse {
  return AuditInfoControllerResponseFromJSONTyped(json, false);
}

export function AuditInfoControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AuditInfoControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : AuditInfoFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function AuditInfoControllerResponseToJSON(value?: AuditInfoControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: AuditInfoToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
